import { render, staticRenderFns } from "./menulist.vue?vue&type=template&id=cd929f62&scoped=true"
import script from "./menulist.vue?vue&type=script&lang=js"
export * from "./menulist.vue?vue&type=script&lang=js"
import style0 from "./menulist.vue?vue&type=style&index=0&id=cd929f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd929f62",
  null
  
)

export default component.exports